import { render, staticRenderFns } from "./ChatSticker.vue?vue&type=template&id=3bb4d8c3"
import script from "./ChatSticker.vue?vue&type=script&lang=js"
export * from "./ChatSticker.vue?vue&type=script&lang=js"
import style0 from "./ChatSticker.vue?vue&type=style&index=0&id=3bb4d8c3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports